export const isCloudflareBlockedBot = (errorResponse) => {
  // Cloudflare bot blocking rules exclusively returns a 403,
  // w/ an Access Denied message in the response data

  const { status, data, config, request } = errorResponse || {};

  const is403Status = status === 403;
  const includesAccessDeniedMsg =
    data && JSON.stringify(data)?.toLowerCase()?.includes('access denied');
  const isWebApi = config?.url?.includes('web-api') || request?.responseURL?.includes('web-api');

  return is403Status && isWebApi && includesAccessDeniedMsg;
};
